module.exports = __webpack_public_path__ + "static/media/jeans.0fdf6c06.jpeg";